import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { DeviceLocationEffects } from './device-location.effects';
import { DeviceLocationReducer, MdmDeviceLocationFeatureKey } from './device-location.reducer';

export const provideDeviceLocationStore = () => [
  provideState(MdmDeviceLocationFeatureKey, DeviceLocationReducer),
  provideEffects([DeviceLocationEffects]),
];
